import React, { ReactElement } from 'react';
import {
  Box,
  Breadcrumbs,
  Page,
  SkeletonCircle,
  SkeletonGroup,
  SkeletonRectangle,
} from '@wix/design-system';

export function EntityPageSkeletonHeader({
  dataHook,
  breadcrumbs,
  onBackClicked,
  showSubtitle,
}: {
  dataHook: string;
  breadcrumbs?: ReactElement<Breadcrumbs>;
  onBackClicked: () => void;
  showSubtitle: boolean;
}) {
  return (
    <Page.Header
      dataHook={dataHook}
      title={<SkeletonRectangle height="24px" width="50%" />}
      subtitle={
        showSubtitle ? (
          <SkeletonRectangle marginTop="SP1" height="12px" width="70%" />
        ) : undefined
      }
      actionsBar={
        <SkeletonGroup>
          <Box gap="SP2" direction="horizontal">
            <SkeletonCircle diameter="36px" />
            <SkeletonRectangle height="36px" width="96px" />
            <SkeletonRectangle height="36px" width="96px" />
          </Box>
        </SkeletonGroup>
      }
      breadcrumbs={breadcrumbs}
      onBackClicked={onBackClicked}
      showBackButton
    />
  );
}

EntityPageSkeletonHeader.displayName = 'Page.Header';
